var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 85 66",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 6.7073816,-0.08371655 36.096621,15.560727 42.080058,0.77183945 50.527259,15.805171 73.933049,1.7496164 61.262249,19.960727 81.324369,19.471838 68.301589,30.838505 85.723949,38.660728 64.957899,38.905172 83.260179,54.182949 57.038649,45.749616 54.222909,62.127394 41.376119,48.927394 23.425809,65.916287 25.185649,44.649616 0.72394456,48.071838 16.034506,34.138505 3.5396866,19.960727 20.962041,22.28295 Z",
    id: "path3508",
    style: {
      fill: "#ff0000",
      stroke: "none",
      strokeWidth: 0.119165
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.082468,8.1388884 38.148786,19.885208 42.641334,8.7812654 48.983749,20.068745 66.557529,9.5154104 57.043899,23.188861 72.107149,22.821789 62.329249,31.356224 75.410479,37.229385 59.818709,37.412921 73.560619,48.883938 53.872689,42.551937 51.758559,54.848866 42.112804,44.937908 28.635161,57.693678 29.956497,41.726023 11.58992,44.295531 23.085554,33.833964 13.704061,23.188861 26.785296,24.932456 Z",
    id: "path3512",
    style: {
      fill: "#ff8000",
      stroke: "none",
      strokeWidth: 0.119165
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.525033,16.621255 39.695351,24.164381 42.580325,17.03377 46.653228,24.282243 57.938569,17.505215 51.829219,26.285886 61.502369,26.050163 55.223299,31.530716 63.623669,35.302279 53.611109,35.420141 62.435739,42.786475 49.792759,38.720258 48.435129,46.616969 42.24092,40.252456 33.585997,48.44382 34.43452,38.189882 22.640058,39.839941 30.022202,33.121844 23.997699,26.285886 32.398058,27.405569 Z",
    id: "path3514",
    style: {
      fill: "#ffff00",
      stroke: "none",
      strokeWidth: 0.119165
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47.137717,32.029133 A 4.4200585,3.0699651 0 1 1 38.2976,32.029133 4.4200585,3.0699651 0 1 1 47.137717,32.029133 Z",
    id: "path3516",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.119165
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoot);
export default __webpack_public_path__ + "static/media/shoot.b1a26dc80994d2f3fc6eb9cc6b742be9.svg";
export { ForwardRef as ReactComponent };